import { useState, useContext } from "react"
import { useNavigate, Link } from "react-router-dom"
import { UserContext } from "../contexts/UserContext"
import { CustomButton } from "../components/global/CustomButton"
import "../styles/signin.css"

export function AdminSignup() {
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [adminSecret, setAdminSecret] = useState("")

    const navigate = useNavigate()

    const userDataContext = useContext(UserContext)
    const { dispatch } = userDataContext

    async function handleAdminSignup() {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/signup`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ name, email, password })
        })
        const json = await response.json()

        if (response.ok) {
            const { user, token } = json
            localStorage.setItem("user2", JSON.stringify({ user, token }))
            dispatch({ type: "LOGIN", payload: { user, token } })
            navigate("/")
        }
    }

    return (
        <div className="signin admin d-flex cntr mx-auto">
            <div className="signin-form p-5 my-3">
                <h3>Exclusive</h3>

                <h2 className="form-title text-center">Sign up as admin</h2>

                <div className="d-flex flex-column mb-4">
                    <input
                        type="text"
                        placeholder="Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Email or Phone number"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Admin Secret"
                        value={adminSecret}
                        onChange={(e) => setAdminSecret(e.target.value)}
                    />
                </div>

                <div className="d-flex flex-column gap-2">
                    <CustomButton
                        color="primary"
                        text="Create Account"
                        btnFunction={handleAdminSignup}
                    />
                </div>

                <div className="mt-5 text-center already-text">
                    Already an admin? <Link to="/adminLogin">Log in</Link>
                </div>
            </div>

        </div>
    )
}